import { Modal } from "./modal";

class Share {
  constructor() {
    this.shareButtons = $(".js-snsShare");
    if (!this.shareButtons.length) { return; }

    if (this.useNavigatorShare(this.shareContent(this.shareButtons.first()))) {
      this.shareButtons.on("click", (e) => {
        navigator.share(this.shareContent($(e.currentTarget)));
      });
    } else {
      new Modal();
    }
  }

  shareContent (shareButton) {
    return {
      url: shareButton.data("shareUrl"),
      text: shareButton.data("shareText"),
    };
  }

  useNavigatorShare (shareContent) {
    return this.isIosOrAndroid() &&
           navigator.canShare &&
           navigator.canShare(shareContent);
  }

  isIosOrAndroid () {
    return /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent||navigator.vendor||window.opera);
  }
}

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const share = new Share();
  }, false);
})();
